var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCollapse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h25v25H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2C2A29",
  d: "M7.415 16.4a.945.945 0 0 1-1.123-.214 1.13 1.13 0 0 1 0-1.515L11.7 8.856a1.076 1.076 0 0 1 1.6 0l5.408 5.815c.296.318.375.8.2 1.208-.231.536-.823.77-1.323.522l-4.135-2.059c-.603-.3-1.298-.3-1.9 0l-4.135 2.059z"
}))));
export { SvgIconCollapse as ReactComponent };
export default __webpack_public_path__ + "img/icon-collapse.e8cc1b6cd03eb90c4b6c49d5b00f73a3.svg";